<template>
  <section class="section reference bg-light auto">
    <SectionTitle :title="$t('about.references.title')" :summary="$t('about.references.desc')"/>
    <div class="inner-content ">
      <div class="reference-grid" data-aos="fade-up" data-aos-delay="600">
        <div
          v-for="(item, index) in $tm('about.references.items')"
          :key="index"
          class="ref-card"
        >
          <div class="ref-info">
            <span class="ref-date">{{ item.date }}</span>
            <h3 class="ref-title">{{ item.title }}</h3>
            <p class="ref-desc">{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'ReferenceList',
  components: { SectionTitle }
}
</script>
